import type { CookieSetOptions } from 'universal-cookie'
import { TIME } from '@/constants/time'

const COOKIE_OPTIONS: CookieSetOptions = {
    path: `/`,
    sameSite: `strict`,
    secure: true
}

/**
 * How long the `access_token` cookie is kept. Must stay **shorter** than the API's refresh window
 * (`JWT_REFRESH_TTL`).
 *
 * While the cookie is the shorter of the two, a token can never be present but past the point of
 * being refreshable: the cookie expires first and the app takes the no-access-token path instead.
 * Make this longer than the refresh window and a user can end up holding a token that cannot be
 * renewed, which the client has no way to recover from.
 */
const ACCESS_TOKEN_LIFETIME = TIME.Week(2)

export { COOKIE_OPTIONS, ACCESS_TOKEN_LIFETIME }
